import { ClientResources, EmploymentDto, PersonDto } from '@app/api2/api';
import * as Yup from 'yup';

export type EmploymentTypeMembers = Pick<PersonDto, 'id' | 'employmentHistory'>;

export const EmploymentItemSchema: Yup.SchemaOf<EmploymentDto> = Yup.object().shape({
    occupation: Yup.string().max(100).label('Occupation').required('Occupation is required'),
    employerName: Yup.string().max(200).label('Employer Name').required('Employer Name is required'),
    employerAddressLine1: Yup.string().max(100).label('Employer Address Line 1').required('Employer Address Line 1 is required'),
    employerAddressLine2: Yup.string().max(100).label('Employer Address Line 2'),
    employerStateName: Yup.string().max(100).label('Employer State Name').optional().nullable().test('state-test', 'State is required', (value, record) => {
        return !!value || !!record.parent.employerStateId;
    }), //.required('State is required'),
    employerStateId: Yup.number().optional().nullable().test('state-test2', 'State is required', (value, record) => {
        return !!value || !!record.parent.employerStateName;
    }).label('Employer State'),
    employerPostal: Yup.string().max(20).label('Employer Postal'),
    // employerCountryk: Yup.string(),
    employerPhone: Yup.string().max(16).label('Employer Phone'),
    employerPostalCode: Yup.string().max(20).label('Employer Postal Code'),
    employerCityId: Yup.number().optional().nullable().label('Employer City').test('city-test', 'City is required', (value, record) => {
        return !!value || !!record.parent.employerCityName;
    }),
    employerCityName: Yup.string().max(100).label('Employer City').test('city-test2', 'City is required', (value, record) => {
        return !!value || !!record.parent.employerCityId;
    }).meta({ search: false }),
    employerCountryId: Yup.number().optional().nullable().label('Employer Country'),
    endDate: Yup.date().optional().nullable().label('End Date') as any,
    id: Yup.number().optional().nullable().meta({ search: false }),
    startDate: Yup.date().optional().nullable().label('Start Date') as any,
}) as Yup.SchemaOf<EmploymentDto>


export const EmploymentSchema: (t: ClientResources) => Yup.SchemaOf<EmploymentTypeMembers> = (t) => Yup.object({
    id: Yup.number().optional().nullable().meta({ search: false }),
    employmentHistory: Yup.array().of(
        EmploymentItemSchema
    ).label(t.metadata.employmentLabel || 'Employment'),
});



type EmploymentTypeMembersObject = Record<(keyof EmploymentTypeMembers), undefined>;

const employmentDefProperties: EmploymentTypeMembersObject = {
    id: undefined,
    employmentHistory: undefined,
};

export const ALL_EMPLOYMENT_PROPERTIES = Object.keys(employmentDefProperties) as (keyof EmploymentTypeMembers)[];

